import React, { useEffect, useMemo } from 'react';
import './GridAnimation.css';

const GridAnimation = () => {
  const gridRange = 10;
  const totalBoxes = gridRange * gridRange;
  
  // Generate random delays and colors once
  const boxProperties = useMemo(() => {
    const properties = [];
    
    // Calculate center position
    const center = (gridRange + 1) / 2;
    
    // Create an array of used delays to avoid duplicates
    const usedDelays = new Set();
    
    for (let row = 1; row <= gridRange; row++) {
      for (let col = 1; col <= gridRange; col++) {
        // Calculate distance from center (0-1 range)
        const distanceFromCenter = Math.sqrt(
          Math.pow((row - center) / gridRange, 2) + 
          Math.pow((col - center) / gridRange, 2)
        ) * 1.414; // Normalize to 0-1 range
        
        // Generate truly random delay (0-5s) with 2 decimal precision
        let delay;
        do {
          delay = (Math.random() * 5).toFixed(2);
        } while (usedDelays.has(delay));
        
        usedDelays.add(delay);
        
        // Calculate blue shade based on distance from center
        // Center is lighter, edges are darker
        const blueValue = Math.max(30, Math.min(220, 220 - distanceFromCenter * 150));
        const color = `rgba(${30 + distanceFromCenter * 20}, ${80 + distanceFromCenter * 40}, ${blueValue}, 0.95)`;
        
        properties.push({
          delay: `${delay}s`,
          color: color
        });
      }
    }
    
    return properties;
  }, [gridRange]);
  
  useEffect(() => {
    document.documentElement.style.setProperty('--grid-range', gridRange);
  }, [gridRange]);

  return (
    <div className="grid-animation-container">
      <div className="wrapper">
        {[...Array(totalBoxes)].map((_, index) => (
          <div 
            className="box" 
            key={index}
            style={{ '--box-animation-delay': boxProperties[index].delay }}
          >
            {[...Array(5)].map((_, planeIndex) => (
              <div 
                className={`box__plane box__plane-${planeIndex + 1}`} 
                key={planeIndex}
                style={{ '--box-color': boxProperties[index].color }}
              ></div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GridAnimation; 